import { EPageType, IPageState } from '../../types/page';
import { TDeviceType } from '@cian/ui-kit';

const defaultPageState: IPageState = {
  type: EPageType.Listing,
  deviceType: 'desktop' as TDeviceType,
};

export function pageReducer(state: IPageState = defaultPageState): IPageState {
  return state;
}
